var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "popup-form popup-cloud"
  }, [_c('div', {
    staticClass: "content-form-popup noselect"
  }, [_c('div', {
    staticClass: "header-text"
  }, [_c('div', {
    staticClass: "back-button-wrapper pointer",
    on: {
      "click": _vm.closePopup
    }
  }, [_c('img', {
    staticClass: "nav-link-icon filter-primary",
    attrs: {
      "src": require("@/images/modal-close.svg"),
      "alt": ""
    }
  })])]), _vm._l(_vm.payload, function (cloudOfMortgage, key) {
    return _c('document-cloud-holder', {
      key: key,
      attrs: {
        "type": _vm.type,
        "extra": _vm.extra,
        "open-on-load": Object.keys(_vm.payload).length === 1,
        "clouds": cloudOfMortgage.clouds,
        "label": cloudOfMortgage.type_label,
        "meta-data": _vm.metaData
      }
    });
  })], 2)]);

}
var staticRenderFns = []

export { render, staticRenderFns }